import React from 'react'
import { Form, Input as AntInput } from 'antd'

import './overrides.css'
import * as Style from './style'

export type TextareaProps = {
  name: string
  labelInline?: boolean
  label?: string
  value?: any
  errors?: any
  handleSubmit?: Function
  setFieldValue: Function
  setFieldTouched: Function
  handleBlur?: Function
  onChangeFunction?: Function
  type?: string
  short?: boolean
  disabled?: boolean
  bindValue?: any
  values: any
  step?: any
  min?: number
  max?: number
  placeholder?: string
  rows?: number
}

const Component = (props: TextareaProps) => {
  const {
    name,
    labelInline,
    label,
    value,
    errors,
    handleSubmit,
    setFieldValue,
    setFieldTouched,
    handleBlur,
    onChangeFunction,
    type,
    short,
    disabled,
    bindValue,
    values,
    step,
    min,
    max,
    placeholder,
    rows,
  } = props

  const conditionalProps: any = {}
  if (bindValue) conditionalProps.value = values[name]

  const onChange = (event: any) => {
    if (!!onChangeFunction) {
      onChangeFunction(event.target.value)
    }
    props.setFieldValue(props.name, event.target.value)
  }

  return (
    <>
      <Form.Item
        hasFeedback={!!errors && !!errors[name]}
        validateStatus={!!errors && errors[name] && 'error'}
        help={!!errors && errors[name]}
        className="inputLabel"
        label={label}
        colon={false}
      >
        <AntInput.TextArea
          name={props.name}
          rows={rows || 5}
          style={props.short ? { width: '90px' } : undefined}
          className={Style.textarea}
          placeholder={placeholder}
          type={props.type}
          disabled={props.disabled}
          value={values[name]}
          defaultValue={!!value ? value : null}
          onChange={(event) => onChange(event)}
          onBlur={() => props.setFieldTouched(props.name)}
          onPressEnter={() => props.handleSubmit}
          {...conditionalProps}
          step={step}
          min={min}
          max={max}
        />
      </Form.Item>
    </>
  )
}

export default Component
